module.exports = __webpack_public_path__ + "static/media/Ramadan1.28d67c8a.jpeg";